import { ISagaModule } from "redux-dynamic-modules-saga";
import { useLoadPersonalization, useSavePersonalization, usePersonalization } from "./hooks";
import { personalizationReducer } from "./reducers";
import { personalizationRootSaga } from "./sagas";
import { getPersonalizationByKey, isPersonalizationDataLoaded } from "./selectors";

export const getPersonalizationModule = (): ISagaModule<any> => ({
    id: "personalization",
    sagas: [personalizationRootSaga],
    reducerMap: {
        personalization: personalizationReducer,
    },
});

export { useLoadPersonalization, useSavePersonalization, usePersonalization };
export { getPersonalizationByKey, isPersonalizationDataLoaded };
